
import React from "react";
import { motion } from "framer-motion";

const AnimatedHeaderBg: React.FC = () => {
  // Generate random colors for bubbles from a kid-friendly palette
  const getRandomKidColor = () => {
    const colors = [
      "from-pink-200 to-purple-200",
      "from-blue-200 to-cyan-200",
      "from-green-200 to-emerald-200",
      "from-yellow-200 to-orange-200",
      "from-indigo-200 to-blue-200"
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };
  
  return (
    <div className="absolute inset-0 overflow-hidden z-0">
      {/* Base light color background */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50" />
      
      {/* Floating balloons */}
      {[...Array(8)].map((_, i) => (
        <motion.div
          key={`bubble-${i}`}
          className={`absolute rounded-full shadow-md bg-gradient-to-r ${getRandomKidColor()}`}
          style={{
            width: `${25 + Math.random() * 60}px`,
            height: `${25 + Math.random() * 60}px`,
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
          }}
          animate={{
            y: [0, -20, 0],
            x: [0, Math.random() * 15 - 7.5, 0],
            scale: [1, 1.1, 1],
            rotate: [0, Math.random() * 10 - 5, 0],
          }}
          transition={{
            duration: 4 + Math.random() * 3,
            repeat: Infinity,
            ease: "easeInOut",
            delay: Math.random() * 2,
          }}
        />
      ))}

      {/* Animated gradient overlay with more opacity */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-r from-blue-100/60 via-purple-100/60 to-pink-100/60"
        animate={{
          backgroundPosition: ["0% 0%", "100% 0%"],
        }}
        transition={{
          duration: 15,
          repeat: Infinity,
          ease: "linear",
          repeatType: "reverse",
        }}
      />

      {/* Sparkles with more visibility */}
      {[...Array(12)].map((_, i) => (
        <motion.div
          key={`star-${i}`}
          className="absolute rounded-full bg-white shadow-sm"
          style={{
            width: `${3 + Math.random() * 4}px`,
            height: `${3 + Math.random() * 4}px`,
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
          }}
          animate={{
            opacity: [0.5, 1, 0.5],
            scale: [0.8, 1.5, 0.8],
          }}
          transition={{
            duration: 1 + Math.random() * 2,
            repeat: Infinity,
            ease: "easeInOut",
            delay: Math.random() * 2,
          }}
        />
      ))}

      {/* Floating shapes (stars, hearts, circles) */}
      {[...Array(4)].map((_, i) => {
        const shapes = [
          "M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z", // star
          "M12 21.593c-5.63-5.539-11-10.297-11-14.402 0-3.791 3.068-5.191 5.281-5.191 1.312 0 4.151.501 5.719 4.457 1.59-3.968 4.464-4.447 5.726-4.447 2.54 0 5.274 1.621 5.274 5.181 0 4.069-5.136 8.625-11 14.402z", // heart
          "M 12, 12 m -9, 0 a 9,9 0 1,0 18,0 a 9,9 0 1,0 -18,0" // circle
        ];
        
        return (
          <motion.svg
            key={`shape-${i}`}
            className="absolute opacity-30"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            style={{
              fill: ["#FF9AA2", "#FFB7B2", "#FFDAC1", "#E2F0CB"][i % 4],
              width: `${20 + Math.random() * 20}px`,
              height: `${20 + Math.random() * 20}px`,
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
            }}
            animate={{
              y: [0, -15, 0],
              x: [0, Math.random() * 20 - 10, 0],
              rotate: [0, 360],
              scale: [0.9, 1.1, 0.9],
            }}
            transition={{
              duration: 5 + Math.random() * 5,
              repeat: Infinity,
              ease: "easeInOut",
              delay: Math.random() * 3,
            }}
          >
            <path d={shapes[i % shapes.length]} />
          </motion.svg>
        );
      })}

      {/* Wave shape with soft color */}
      <svg 
        className="absolute bottom-0 left-0 w-full h-10 text-blue-50" 
        viewBox="0 0 1200 120" 
        preserveAspectRatio="none"
      >
        <path 
          d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" 
          className="fill-current" 
        />
      </svg>
    </div>
  );
};

export default AnimatedHeaderBg;
